import { Action, ActionProps } from "../action";
import { forwardRef } from "react";
import { TbPointer } from "react-icons/tb";

export const Pointer = forwardRef<HTMLButtonElement, ActionProps>(
  (props: ActionProps, ref) => {
    return <Action {...props} ref={ref} Icon={TbPointer} />;
  }
);
